import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import parse from "html-react-parser";

import "react-quill/dist/quill.snow.css"; // Include CSS

import {
  convertFirstLetterOfFullNameToCapital,
  convertFirstLetterToCapital,
  decryptWithAES
} from "../../helpers/commonHelpers";

const ViewMinuteModal = (props) => {
  const { minuteData } = props;
  return (
    <>
      <Modal
        size="lg"
        show={props.IsViewMinuteModal}
        onHide={(e) => props.setIsViewMinuteModal(false)}
        backdrop="static"
      >
        <div className="modal-header attendees-modal">
          <div>
            <h4 className="modal-title">View Minute</h4>
          </div>
          <div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={(e) => props.setIsViewMinuteModal(false)}
            ></button>
          </div>
        </div>

        <Modal.Body className="attendees-popup modal-margin">
          <div className="open-div">
            <form className="addminutesboxfrom">
              <div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">Minutes Title</label>
                    </div>
                    <div className="col-md-12">
                      <p>{minuteData?.title}</p>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">Description</label>
                    </div>
                    <div className="col-md-82">
                      {minuteData?.description
                        ? parse(decryptWithAES(minuteData.description))
                        : null}

                    </div>
                  </div>
                </div>
                <div className=" form-group ">
                  <div className="row">
                    <div className="col-md-4">
                      <label className="mt-1 mb-1">Status</label>
                    </div>
                    <div className="col-md-6">
                      <p>
                        {minuteData.status === "DRAFT" ? (
                          <span className="badge bg-opacity-10 draft-color">
                            {minuteData?.status
                              ? convertFirstLetterToCapital(minuteData?.status)
                              : null}
                          </span>
                        ) : (
                          <span className="badge bg-opacity-10 scheduled-color">
                            {minuteData?.status
                              ? convertFirstLetterToCapital(minuteData?.status)
                              : null}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="add-action">
                  {minuteData.isAction ? (
                    <>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                          <div className="form-group">
                            <div className="position-relative">
                              <label className="pb-2 input-date">
                                {" "}
                                Due Date
                              </label>
                              {minuteData?.dueDate}
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                          <div className="form-group">
                            <div className="position-relative">
                              <label className="pb-2 input-date">
                                Priority
                              </label>
                              <div>{minuteData?.dueDate}</div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group pb-3 border-bottom">
                          <label className="pb-2">Responsible Person</label>
                          <div className="w-100">
                            {minuteData?.assignedUserDetails?.name
                              ? convertFirstLetterOfFullNameToCapital(
                                minuteData?.assignedUserDetails?.name
                              )
                              : null}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewMinuteModal;
